import { createSlice } from "@reduxjs/toolkit";

const locationSlice = createSlice({
  name: "location",
  initialState: {
    location: {
      label: "",
      value: "",
    },
  },
  reducers: {
    changeLocation: (state, action) => {
      state.location = {
        label: action.payload.label, 
        value: action.payload.value,
      };
    },
  },
});

export const { changeLocation } = locationSlice.actions;
export default locationSlice.reducer;
